import { AppDispatch, RootState } from "../../../../../ReduxToolkit/Store";
import { clearReduxMessages } from "../../../../../utils/reduxUtils/clearReduxMessages";
import {
  clearEmployeeUnderProbationError,
  clearEmployeeUnderProbationSuccess,
} from "../../../../hrZone/EmployeeProbation/redux/slice/EmployeeProbationListSlice";
import {
  clearEmployeeUpdateProbationError,
  clearEmployeeUpdateProbationSuccess,
} from "../../../../hrZone/EmployeeProbation/redux/slice/EmployeeUpdateProbationSlice";
import {
  clearTeamMembersListError,
  clearTeamMembersListSuccess,
} from "../slice/teamMembersListSlice";

const clearTeamMembersStates = [
  clearTeamMembersListError,
  clearTeamMembersListSuccess,
  clearEmployeeUpdateProbationError,
  clearEmployeeUpdateProbationSuccess,
  clearEmployeeUnderProbationError,
  clearEmployeeUnderProbationSuccess,
];

export const selectTeamMembersListLoading = (state: RootState) =>
  state.teamMembers.loading;

export const selectTeamMembersList = (state: RootState) =>
  state.teamMembers.data;

export const selectTeamMembersListError = (state: RootState) =>
  state.teamMembers.error;

export const selectTeamMembersUnderProbationList = (state: RootState) =>
  state.teamMembers.data?.data.probation_members;

export const clearTeamMembersListStates = (dispatch: AppDispatch) =>
  clearReduxMessages(dispatch, clearTeamMembersStates);
